import { Card } from "@mui/material";
import { COLOR_VERY_LIGHT_GRAY } from "../../data/colors/Colors";

interface props {
  children: React.ReactElement;
  padding?: number;
  borderRadius?: number;
  background?: string;
  border?: string;
  height?: number | string;
  minHeight?: number | string;
  maxHeight?: number | string;
  width?: number | string;
  maxWidth?: number | string;
  elevation?: number;
}

export function CustomCardView(props: props) {
  return (
    <Card
      elevation={props.elevation ?? 0}
      sx={{
        background: props.background ?? COLOR_VERY_LIGHT_GRAY,
        p: props.padding ?? 4,
        borderRadius: props.borderRadius ?? 8,
        height: props.height,
        minHeight: props.minHeight,
        maxHeight: props.maxHeight,
        maxWidth: props.maxWidth,
        width: props.width,
        border: props.border ?? "1px solid lightGray",
      }}
    >
      {props.children}
    </Card>
  );
}
